import { useCallback, useRef } from 'react'

// フォーカス時や入力時などの検索が同時に走ると、解決順序によっては古い結果で
// 新しい結果を上書きしてしまう。最新のリクエストの結果だけを反映する。
export const useLatestSearch = <Entity>(
  search: ((searchText: string) => Promise<Entity[]>) | undefined,
  onResult: (options: Entity[]) => void
): ((searchText: string) => Promise<void>) => {
  const latestRequestId = useRef(0)
  return useCallback(
    async (searchText: string) => {
      if (!search) return
      const requestId = ++latestRequestId.current
      const response = await search(searchText)
      if (requestId !== latestRequestId.current) return
      onResult(response)
    },
    [search, onResult]
  )
}
